// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__1dUT4","container":"styles_container__2VR70","paper":"styles_paper__19537","logoBig":"styles_logoBig__1otPZ","logoSmall":"styles_logoSmall__2KKrw"};